import { action } from '../../action-factory'
import { ActionFactory } from '../../types/core'
import { CLEAR_OFFER_ACTIVITIES, ClearOfferActivities } from './types/actions'

export const clearOfferActivities: ActionFactory<ClearOfferActivities> = action(CLEAR_OFFER_ACTIVITIES)
